import { gql } from '@apollo/client';

export default gql`
  query getSearchServiceDetails($travelDate: String!, $serviceType: String!, $originUIC: String, $destinationUIC: String) {
    getSearchServiceDetails(travelDate: $travelDate, serviceType: $serviceType, originUIC: $originUIC, destinationUIC: $destinationUIC) {
      serviceIdentifier
      trainNumber
      numberOfStations
      stations {
        name
        uicCode
      }
    }
  }
`;
